import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaShoppingCart } from 'react-icons/fa';

function PostCard({ post, onFavorite }) {
  return (
    <div className="post-card">
      <img src={post.image} alt={post.title} className="post-image" />
      <div className="post-content">
        <h3>{post.title}</h3>
        <div className="post-meta">
          <span>{post.date}</span>
          <span>{post.author}</span>
        </div>
        <p className="post-excerpt">{post.excerpt}</p>
        <div className="post-actions">
          <Link to={`/post/${post.id}`} className="btn btn-primary">
            Διαβάστε Περισσότερα
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PostCard;